// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"App_layoutWrapper__DWYW9","contentWrapper":"App_contentWrapper__p2cwb"};